import { render, staticRenderFns } from "./AlertCountdown.vue?vue&type=template&id=617bd360&"
import script from "./AlertCountdown.vue?vue&type=script&lang=js&"
export * from "./AlertCountdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports